// import React, { useEffect, useState } from 'react';
// import {
//   Box, Tabs, Tab, Select, MenuItem, TextField,
//   InputLabel, FormControl, ToggleButtonGroup, ToggleButton
// } from '@mui/material';
// import OutstandingTable from './OutstandingTable';
// import { OutstandingRecord } from '../../types/outstanding';
// import { getAllEmployees, getAllCustomers, type Employee } from "./OutstandingAnalysisService";

// const mockData: OutstandingRecord[] = [
//   { id: 'c1', name: 'Jane Doe', balance: -5000, type: 'customer', lastTransactionDate: '2025-06-25', contactInfo: '08012345678' },
//   { id: 'c2', name: 'Mike Smith', balance: 2000, type: 'customer', lastTransactionDate: '2025-06-24' },
//   { id: 'v1', name: 'ABC Supplies', balance: 10000, type: 'vendor', lastTransactionDate: '2025-06-20' },
//   { id: 'v2', name: 'XYZ Vendors', balance: -8000, type: 'vendor', lastTransactionDate: '2025-06-18' },
//   { id: 's1', name: 'John Staff', balance: 15000, type: 'staff', lastTransactionDate: '2025-06-18', details: 'Salary' },
//   { id: 's2', name: 'Kate Admin', balance: -2000, type: 'staff', lastTransactionDate: '2025-06-17', details: 'Advance' },
// ];

// const OutstandingAnalysis: React.FC = () => {
//   const [data, setData] = useState<OutstandingRecord[]>([]);
//   const [tab, setTab] = useState(0); // 0 = general, 1 = customer, 2 = vendor, 3 = staff
//   const [selectedName, setSelectedName] = useState<string>('');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [balanceType, setBalanceType] = useState<'positive' | 'negative'>('negative');
//   const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(5);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState<string | null>(null);
//     const [staffs, setStaffs] = useState<Employee[]>([]);
//     const [customers, setCustomers] = useState<Employee[]>([]);
//     const [vendors, setVendors] = useState<Employee[]>([]);

//   useEffect(() => {
//       setData(mockData);
//         fetchSalesEmployees();
//   }, []);

//         const fetchSalesEmployees = async () => {
//         try {
//           setLoading(true)
//             //   const data = await getAllEmployees()
//             const [employees, customers, vendors] = await Promise.all([
//                 getAllEmployees(),
//                 getAllCustomers(),
//                 getAllEmployees(), // Assuming this fetches vendors as well
//             ]);
//             console.log("Fetched employees:", data)

//             //   setEmployees(data)
//             // setStaffs(employees.filter((emp) => emp.roleID === '14'));
//             // setCustomers(customers.filter((emp) => emp.roleID === '13')); // Assuming roleID '13' is for customers
//             // setVendors(vendors.filter((emp) => emp.roleID === '15')); //
//             setStaffs(employees)
//             setCustomers(customers)
//             setVendors(vendors)

//         } catch (err) {
//           setError("Failed to load onboarding employees")
//           console.error(err)
//         } finally {
//           setLoading(false)
//         }
//       }

//   const handleTabChange = (_: any, newTab: number) => {
//     setTab(newTab);
//     setSelectedName('');
//     setSearchTerm('');
//     setPage(0);
//   };

//   const handleBalanceToggle = (_: any, value: 'positive' | 'negative' | null) => {
//     if (value !== null) {
//       setBalanceType(value);
//       setPage(0);
//     }
//   };

//   const filteredData = data.filter((record) => {
//     const matchTab =
//       tab === 0 ||
//       (tab === 1 && record.type === 'customer') ||
//       (tab === 2 && record.type === 'vendor') ||
//       (tab === 3 && record.type === 'staff');

//     const matchBalance =
//       balanceType === 'positive' ? record.balance > 0 : record.balance < 0;

//     const matchName = selectedName ? record.name === selectedName : true;

//     const matchSearch = record.name.toLowerCase().includes(searchTerm.toLowerCase());

//     return matchTab && matchBalance && matchName && matchSearch;
//   });

//   const dropdownOptions = [...new Set(data
//     .filter(r => {
//       if (tab === 1) return r.type === 'customer';
//       if (tab === 2) return r.type === 'vendor';
//       if (tab === 3) return r.type === 'staff';
//       return false;
//     })
//     .map(r => r.name))];

//   return (
//     <Box sx={{ p: 2 }}>
//       <Tabs value={tab} onChange={handleTabChange} centered>
//         <Tab label="General" />
//         <Tab label="Customers" />
//         <Tab label="Vendors" />
//         <Tab label="Staff" />
//       </Tabs>

//       <Box display="flex" flexWrap="wrap" gap={2} mt={2} alignItems="center">
//         {tab > 0 && (
//           <FormControl size="small" sx={{ minWidth: 200 }}>
//             <InputLabel>Select {['', 'Customer', 'Vendor', 'Staff'][tab]}</InputLabel>
//             <Select
//               value={selectedName}
//               label={`Select ${['', 'Customer', 'Vendor', 'Staff'][tab]}`}
//               onChange={(e) => setSelectedName(e.target.value)}
//             >
//               {dropdownOptions.map((name) => (
//                 <MenuItem key={name} value={name}>{name}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         )}

//         <ToggleButtonGroup
//           size="small"
//           value={balanceType}
//           exclusive
//           onChange={handleBalanceToggle}
//         >
//           <ToggleButton value="negative">Negative Balance</ToggleButton>
//           <ToggleButton value="positive">Positive Balance</ToggleButton>
//         </ToggleButtonGroup>

//         <TextField
//           label="Search"
//           size="small"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </Box>

//       <OutstandingTable
//         title="Outstanding Records"
//         data={filteredData}
//         page={page}
//         rowsPerPage={rowsPerPage}
//         onPageChange={(_, newPage) => setPage(newPage)}
//         onRowsPerPageChange={(e) => {
//           setRowsPerPage(parseInt(e.target.value, 10));
//           setPage(0);
//         }}
//       />
//     </Box>
//   );
// };

// export default OutstandingAnalysis;

import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  ToggleButtonGroup,
  ToggleButton,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import OutstandingTable from "./OutstandingTable";
import { OutstandingRecord } from "../../types/outstanding";
import {
  getAllEmployees,
  sendBatchReminders,
  getAllCustomers,
  getAllVendors,
  type Employee,
} from "./OutstandingAnalysisService";
import ReminderDialog from "./ReminderDialog";
import { IonContent, IonHeader, IonPage, IonText, IonTitle } from "@ionic/react";

const OutstandingAnalysis: React.FC = () => {
  const [data, setData] = useState<OutstandingRecord[]>([]);
  const [tab, setTab] = useState(0); // 0 = general, 1 = customer, 2 = vendor, 3 = staff
  const [selectedName, setSelectedName] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [balanceType, setBalanceType] = useState<"positive" | "negative">(
    "negative"
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [showReminderDialog, setShowReminderDialog] = useState(false);

  useEffect(() => {
    fetchOutstandingData();
  }, []);

  const fetchOutstandingData = async () => {
    try {
      setLoading(true);
      const [employees, customers, vendors] = await Promise.all([
        getAllEmployees(),
        getAllCustomers(),
        getAllVendors(),
      ]);

      const transformToRecord = (
        items: Employee[],
        type: "customer" | "vendor" | "staff"
      ): OutstandingRecord[] =>
        items.map((item) => ({
          id: item.id,

          name: `${item.firstName} ${item.lastName}`,
          user_id: item.user_id,
          userName: item.userName,
          department: item.department,
          position: item.position,
          email: item.email,
          phone: item.phone,
          legbal: item.ledgerbal || item.balance || 0,
          type,
          lastTransactionDate: item.last_updated || new Date().toISOString(),
          contactInfo: item.contact || "",
          details: item.details || "",
        }));

      const allRecords: OutstandingRecord[] = [
        ...transformToRecord(customers, "customer"),
        ...transformToRecord(vendors, "vendor"),
        ...transformToRecord(employees, "staff"),
      ];

      setData(allRecords);
    } catch (err) {
      console.error(err);
      setError("Failed to load data.");
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (_: any, newTab: number) => {
    setTab(newTab);
    setSelectedName("");
    setSearchTerm("");
    setPage(0);
  };

  const handleBalanceToggle = (
    _: any,
    value: "positive" | "negative" | null
  ) => {
    if (value !== null) {
      setBalanceType(value);
      setPage(0);
    }
  };

  const handleSendReminders = async (
    message: string,
    method: "email" | "sms" | "both"
  ) => {
    await sendBatchReminders(
      selectedIds,
      message,
      method,
      tab === 0 ? "all" : (["customer", "vendor", "staff"][tab] as any)
    );
    setSelectedIds([]); // Clear selection after success
  };

  const filteredData = data.filter((record) => {
    const matchTab =
      tab === 0 ||
      (tab === 1 && record.type === "customer") ||
      (tab === 2 && record.type === "vendor") ||
      (tab === 3 && record.type === "staff");

    const matchBalance =
      balanceType === "positive" ? record?.legbal > 0 : record?.legbal < 0;

    const matchName = selectedName ? record?.name === selectedName : true;

    const matchSearch = record?.name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

    return matchTab && matchBalance && matchName && matchSearch;
  });

  const dropdownOptions = [
    ...new Set(
      data
        .filter((r) => {
          if (tab === 1) return r.type === "customer";
          if (tab === 2) return r.type === "vendor";
          if (tab === 3) return r.type === "staff";
          return false;
        })
        .map((r) => r.name)
    ),
  ];

  return (
    <IonPage>
      <IonHeader>
        <IonTitle>
          <IonText>Hey</IonText>
        </IonTitle>
      </IonHeader>
      <IonContent>
        <Box sx={{ p: 2 }}>
          <Tabs value={tab} onChange={handleTabChange} centered>
            <Tab label="General" />
            <Tab label="Customers" />
            <Tab label="Vendors" />
            <Tab label="Staff" />
          </Tabs>

          <Box
            display="flex"
            flexWrap="wrap"
            gap={2}
            mt={2}
            alignItems="center"
          >
            {tab > 0 && (
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>
                  Select {["", "Customer", "Vendor", "Staff"][tab]}
                </InputLabel>
                <Select
                  value={selectedName}
                  label={`Select ${["", "Customer", "Vendor", "Staff"][tab]}`}
                  onChange={(e) => setSelectedName(e.target.value)}
                >
                  {dropdownOptions.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            <ToggleButtonGroup
              size="small"
              value={balanceType}
              exclusive
              onChange={handleBalanceToggle}
            >
              <ToggleButton value="negative">Negative Balance</ToggleButton>
              <ToggleButton value="positive">Positive Balance</ToggleButton>
            </ToggleButtonGroup>

            <TextField
              label="Search"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>

          {loading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error" mt={4}>
              {error}
            </Typography>
          ) : (
            <>
              {selectedIds.length > 0 && (
                <Box mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SendIcon />}
                    onClick={() => setShowReminderDialog(true)}
                  >
                    Send Reminder to {selectedIds.length} Selected
                  </Button>
                </Box>
              )}
              <OutstandingTable
                title="Outstanding Records"
                data={filteredData}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={(_, newPage) => setPage(newPage)}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                selectedIds={selectedIds}
                onSelectChange={(ids) => setSelectedIds(ids)}
              />
            </>
          )}
          <ReminderDialog
            open={showReminderDialog}
            onClose={() => setShowReminderDialog(false)}
            onSend={handleSendReminders}
          />
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default OutstandingAnalysis;
